const CallDetailsAnalytics = ({
	summary,
	endedCallReason,
	status,
	fromNumber,
	guestInformation,
	metaData
}: {
	summary: string,
	endedCallReason: string,
	status: string,
	fromNumber?: string,
	guestInformation: {
		// eslint-disable-next-line camelcase
		guest_name: string,
		email:string
	},
	metaData: {
		[key: string]: string
	}
}) => {
	return (
		<div className="whitespace-pre-line text-gray-600 dark:text-white text-sm font-normal">
			<h4 className="text-gray-500 dark:text-white mb-8">Analytics</h4>
			<div className="mb-4">
				<h4 className="text-black dark:text-white font-bold text-sm mb-1">Summary</h4>
				<p className="text-sm">{summary}</p>
			</div>
			<div className="mb-4">
				<h4 className="text-black dark:text-white font-bold text-sm mb-1">Ended call Reason</h4>
				<p className="text-sm">{endedCallReason}</p>
			</div>
			<div className="mb-4">
				<h4 className="text-black dark:text-white font-bold text-sm mb-1">Status</h4>
				<p className="text-sm">{status}</p>
			</div>
			<div className="mb-4">
				<h4 className="text-black dark:text-white font-bold text-sm mb-1">Guest Information</h4>
				<p className="text-sm">{guestInformation.email} <br />{guestInformation.guest_name}</p>
			</div>
			{fromNumber && (
				<div className="mb-4">
					<h4 className="text-black dark:text-white font-bold text-sm mb-1">From Number</h4>
					<p className="text-sm">{fromNumber}</p>
				</div>
			)}
			<div className="mb-4">
				<h4 className="text-black dark:text-white font-bold text-sm mb-1">Meta Data</h4>
				<p className="text-sm">
					{Object.values(metaData).length === 0 && '/'}
					{Object.values(metaData).map(value => <p key={value}>{value}</p>)}
				</p>
			</div>
		</div>
	) 
}

export default CallDetailsAnalytics;